__turbopack_context__.v({
  "className": "noto_sans_lao_48258008-module__Abl6gq__className",
});
